import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { GlobalServices } from '../../../services/global.service';
import { MessagingService } from '../../../services/messaging.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { Message, MessageAttachments } from '../../../models/message.model';
import { ResponseObject } from '../../../models/response-object.model';
import { Languages } from 'src/app/shared/models/enums.model';
import { fileService } from 'src/app/front-user/shared/services/file.service';
import { AppConfig } from 'src/app/shared/services/app.config';
import { TranslateService } from '@ngx-translate/core';
import { HttpResponse } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute } from '@angular/router';
declare function GetRequestMessages(pchat: any, requestId: string): void;
declare function GetETenderMessages(pchat: any, tenderId: string, supplierId: string): void;
declare var chat: any;
declare var upUrl: any;
declare var isMessagingAdmin: any;
declare function OpenHubConnection(reqId): any;
declare function OpenETenderHubConnection(tenderId, supplierId): any;
declare var isRegistration;
declare var BaseRequestId;
declare var regRequestId;

@Component({
    selector: 'app-messaging',
    templateUrl: './message.component.html'
})

export class MessageComponent implements OnInit {
    @Input() RegestRequestId: string;
    @Input() isMessageBoxDisabled = false;
    private responseObject: ResponseObject = new ResponseObject();
    public currentUser: User = new User();
    public currentLanguage;
    public requestNumber: any;
    public requestId: any;
    public RelatedRegestRequestId: any;
    public showMessaging = false;
    public messageFailed = false;
    public isFileExtentionNotAllowed = false;
    public isFileSizeNotAllowed = false;
    public showMessagingHistory = false;
    public messagingHistory = [];
    private message: Message = new Message();
    private messageAttachment: MessageAttachments = new MessageAttachments();
    uploadUrl = AppConfig.settings.apiServer.UploadsUrl;
    uploadEvent: any;
    DocumentName: string;
    @Input() MessagingBoxTitle: string;
    messageBoxTitle: string;
    isTender = false;
    isGeneralMessage = false;
    supplierId: any;
    isUserInAnyMessagingGroup: any;
    isAdmin: boolean;
    isSending = false;

    constructor(private cookieService: CookieService,private global: GlobalServices, private messagingService: MessagingService,
                private authenticationService: AuthenticationService, private fileService: fileService,
                private translate: TranslateService, private route: ActivatedRoute,
    ) {
        
        this.currentUser = this.authenticationService.currentUserValue;
        this.isAdmin = this.currentUser.IsAdmin;
        //this.currentUser = this.global.user;
        
        /*if(localStorage.getItem('RequestId'))
        {
            this.requestId = localStorage.getItem('RequestId');
        }
        */
        if(this.cookieService.get('RelatedRequestId')){

            this.RelatedRegestRequestId = this.cookieService.get('RelatedRequestId');;
        }
    }

    ngOnInit() {
        
        if (this.currentUser.IsAdmin) {
            if (this.RelatedRegestRequestId) {

                this.requestId = this.RelatedRegestRequestId;
                BaseRequestId = this.RelatedRegestRequestId;
                this.cookieService.delete('RelatedRequestId')
                this.initializeMessaging();
            }
            if (this.RegestRequestId) {
                this.requestId = this.RegestRequestId;
                BaseRequestId = this.RegestRequestId;

                this.messagingService.CheckUserInMessagingSPGroups(this.currentUser.UserName, BaseRequestId).subscribe(
                    data => this.isUserInAnyMessagingGroup = data.Data,
                    () => console.log('Something went wrong!!'),
                    () => this.initializeAdminMessaging()
                );
            } else if (history.state.data && history.state.data.requestId) {
                this.requestId = history.state.data.requestId;
                BaseRequestId = history.state.data.requestId;

                this.messagingService.CheckUserInMessagingSPGroups(this.currentUser.UserName, BaseRequestId).subscribe(
                    data => this.isUserInAnyMessagingGroup = data.Data,
                    () => console.log('Something went wrong!!'),
                    () => this.initializeAdminMessaging()
                );

            }
            else if (history.state.data && history.state.data.tenderId)
            {
                this.requestId = history.state.data.tenderId;
                this.initializeMessaging();
            }
        }
        else
        {
            if (this.RegestRequestId)
            {
                this.requestId = this.RegestRequestId;
                BaseRequestId = this.RegestRequestId;
                this.initializeMessaging();
            }
            else if (history.state.data && history.state.data.requestId)
            {
                this.requestId = history.state.data.requestId;
                BaseRequestId = history.state.data.requestId;
                this.initializeMessaging();
            }
            else if (history.state.data && history.state.data.tenderId)
            {
                this.requestId = history.state.data.tenderId;
                this.initializeMessaging();
            }
        }
    }

    ngAfterViewInit()
    { }

    initializeAdminMessaging() {
       
        if (this.isUserInAnyMessagingGroup) {
            this.initializeMessaging();
        }
    }

    async initializeMessaging() {
        this.messageBoxTitle = this.MessagingBoxTitle == undefined ?
            await this.translate.get('SHARED.Messages').toPromise() :
            await this.translate.get('SHARED.' + this.MessagingBoxTitle).toPromise();

        this.isGeneralMessage = this.MessagingBoxTitle == 'GeneralMessages';
        this.currentLanguage = this.global.getLanguage() == Languages.Arabic ? 'Ar' : 'En';
        if (BaseRequestId) {
            this.buildNewMessage();
        } else if (history.state.data && history.state.data.tenderId) {
            this.isTender = true;
            if (history.state.data != undefined && history.state.data.supplierId != undefined) {
                this.supplierId = history.state.data.supplierId;
            }
            this.buildETenderNewMessage();
        }

    }
    buildNewMessage() {
        this.messagingService.getNewMessageDetailsByRequestId(this.requestId, this.currentUser.IsAdmin).subscribe(
            data => this.message = data.Data,
            () => this.showMessaging = false,
            () => this.getNewMessageDetailsSucceeded()
        );
    }

    buildETenderNewMessage() {
        this.messagingService.getETenderNewMessageDetailsByTenderId(this.requestId, this.currentUser.IsAdmin,
            this.supplierId == undefined ? '' : this.supplierId).subscribe(
                data => this.message = data.Data,
                () => this.showMessaging = false,
                () => this.getNewMessageDetailsSucceeded()
            );
    }

    getNewMessageDetailsSucceeded() {
        this.showMessaging = true;
        upUrl = AppConfig.settings.apiServer.UploadsUrl + AppConfig.settings.apiServer.MessagesUploadsFolder + '/';
        isMessagingAdmin = this.currentUser.IsAdmin;
        if (this.currentUser.IsAdmin && this.message.MessageReceivers.length > 0) {
            this.message.MessageReceivers.forEach(mr => mr.SenderAdminEmail = this.currentUser.Email);
        }

        if (this.isTender) {
            OpenETenderHubConnection(this.requestId, this.supplierId);
        }
        else {
            OpenHubConnection(this.requestId);
        }
    }

    getMessagingHistoryByRequestId() {
        this.messagingService.getMessagingHistoryByRequestId(this.requestId).subscribe(
            data => this.messagingHistory = data.Data,
            () => console.log('Something went wrong...'),
            () => this.getMessagingHistorySucceeded()
        );
    }

    getMessagingHistorySucceeded() {
        this.showMessagingHistory = true;
    }

    sendMessage() {
        this.isSending = true;
        if (this.message.Body != undefined && this.message.Body != '') {
            this.message.Subject = this.message.Body.slice(0, 149);
            if (this.message.MessageAttachments == null) {
                this.Send();
            }
        }
        if (this.message.MessageAttachments != null) {
            if (this.message.Body == undefined || this.message.Body == null || this.message.Body == '') {
                this.message.Body = this.message.Subject = this.currentLanguage == 'Ar' ? "جاري إرسال الملف..." : "Sending File...";
            }
            this.uploadAndSend();
        }
    }

    sendMessageSuceeded() {
        if (this.responseObject.Success) {
            this.message.Body = '';
            this.message.Subject = '';
            this.isFileExtentionNotAllowed = false;
            this.isFileSizeNotAllowed = false;
            this.messageFailed = false;
            this.removeFile();

            if (this.isTender) {
                GetETenderMessages(chat, this.requestId, this.supplierId);
            }
            else {
                GetRequestMessages(chat, this.requestId);
            }
        } else {
            this.isFileExtentionNotAllowed = false;
            this.isFileSizeNotAllowed = false;
            this.messageFailed = true;

        }
        this.isSending = false;
    }

    sendMessageFailed() {
        this.isFileExtentionNotAllowed = false;
        this.isFileSizeNotAllowed = false;
        this.messageFailed = true;
        this.isSending = false;
    }

    removeErrors() {
        this.isFileExtentionNotAllowed = false;
        this.isFileSizeNotAllowed = false;
        this.messageFailed = false;
    }

    public onFileSelected(event, currFormControl) {
        // this.DocumentName = this.message.MessageAttachments.toString().slice(this.message.MessageAttachments.toString().lastIndexOf("\\") + 1);
        this.DocumentName = this.message.MessageAttachments[0].name;
        if (!this.fileService.IsFileExtentionValid(event)) {
            this.isFileExtentionNotAllowed = true;
            this.isFileSizeNotAllowed = false;
            this.messageFailed = false;
            this.removeFile();
            return false;
        }
        if (!this.fileService.IsFileSizeValid(event)) {
            this.isFileExtentionNotAllowed = false;
            this.isFileSizeNotAllowed = true;
            this.messageFailed = false;
            this.removeFile();
            return false;
        }
        this.isFileExtentionNotAllowed = false;
        this.isFileSizeNotAllowed = false;
        this.messageFailed = false;
        this.uploadEvent = event;
    }

    uploadAndSend() {
        // Upload
        const file = this.uploadEvent.target.files[0];
        let formData = new FormData();
        formData.append('File', file);
        if (this.isTender) {
            var docName = "Messages_T" + this.message.ETenderId + "_" + file.name.split('.').slice(0, -1).join('.');
        }
        else {
            var docName = "Messages_" + this.message.RequestNumber + "_" + file.name.split('.').slice(0, -1).join('.');
        }
        formData.append('DocumentName', docName);
        formData.append('FolderName', AppConfig.settings.apiServer.MessagesUploadsFolder);

        this.fileService.fileUploader(formData).subscribe(
            event => {
                if (event instanceof HttpResponse) {
                    let jsonResponse = event.body.Data;
                    let Url = jsonResponse.Url;
                    this.message.MessageAttachments = Url;
                    this.Send();
                }
            }
        );
    }

    removeFile() {
        this.message.MessageAttachments = null;
        this.DocumentName = '';
        document.forms.namedItem('aspnetForm').reset();
    }

    Send() {
        if (this.message.MessageAttachments != null) {
            this.messageAttachment.DocumentName = this.message.MessageAttachments.toString();
            this.message.MessageAttachments = [this.messageAttachment];
        }
        if (this.isTender) {
            if (this.currentUser.IsAdmin) {
                this.messagingService.sendAdminETenderMessage(this.message).subscribe(
                    data => this.responseObject = data,
                    () => this.sendMessageFailed(),
                    () => this.sendMessageSuceeded()
                );
            } else {
                this.messagingService.sendUserETenderMessage(this.message).subscribe(
                    data => this.responseObject = data,
                    () => this.sendMessageFailed(),
                    () => this.sendMessageSuceeded()
                );
            }
        } else {
            if (this.currentUser.IsAdmin) {
                this.messagingService.sendAdminMessage(this.message).subscribe(
                    data => this.responseObject = data,
                    () => this.sendMessageFailed(),
                    () => this.sendMessageSuceeded()
                );
            } else {
                this.messagingService.sendUserMessage(this.message).subscribe(
                    data => this.responseObject = data,
                    () => this.sendMessageFailed(),
                    () => this.sendMessageSuceeded()
                );
            }
        }
    }

    markMyReceivedMessagesAsRead() {
        if (this.isTender) {
            if (this.currentUser.IsAdmin) {
                this.messagingService.markAdminReceivedETenderMessagesAsRead(this.requestId, this.message.MessageReceivers[0].SenderSPGroupId).subscribe(
                    data => this.responseObject = data,
                    () => this.sendMessageFailed(),
                    () => this.sendMessageSuceeded()
                );
            }
            else {
                this.messagingService.markUserReceivedETenderMessagesAsRead(this.requestId, this.currentUser.UserId).subscribe(
                    data => this.responseObject = data,
                    () => this.sendMessageFailed(),
                    () => this.sendMessageSuceeded()
                );
            }
        } else {
            if (this.currentUser.IsAdmin) {
                this.messagingService.markAdminReceivedMessagesAsRead(this.requestId, this.message.MessageReceivers[0].SenderSPGroupId).subscribe(
                    data => this.responseObject = data,
                    () => this.sendMessageFailed(),
                    () => this.sendMessageSuceeded()
                );
            }
            else {
                this.messagingService.markUserReceivedMessagesAsRead(this.requestId, this.currentUser.UserId).subscribe(
                    data => this.responseObject = data,
                    () => this.sendMessageFailed(),
                    () => this.sendMessageSuceeded()
                );
            }
        }
    }

    printMessages() {
        var css1 = '<link rel="stylesheet" type="text/css" href="/Style%20Library/CSS/scaCommon.css"/>';
        var css2;
        if (window.location.href.toLowerCase().indexOf("/english/") > 0)
            css2 = '<link rel="stylesheet" type="text/css" href="/Style%20Library/CSS/scaLTR.css"/>';
        else css2 = '<link rel="stylesheet" type="text/css" href="/Style%20Library/CSS/scaRTL.css"/>';

        // var t=$("h1.mainTitle").html();
        var requestNo_title = this.translate.instant('SHARED.MyMessages.RequestNumber');
        var requestNo = this.message.RequestNumber;
        var ServiceName_title = this.translate.instant('SHARED.MyMessages.ServiceName');
        var ServiceName = this.currentLanguage == "Ar" ? this.message.ServiceNameAR : this.message.ServiceNameEN;
        //var messagesHeader = document.getElementsByClassName('chat-head')[0].innerHTML;
        var messagesBody = document.getElementsByClassName('chat-body')[0].innerHTML;
        var r = window.open(window.location.href, "_blank", "status=0,toolbar=no,height=400,width=700,top=0,left=0,menubar=no,scrollbars=yes,titlebar=0");
        r.document.open();
        // r.document.write("<html><head><title>Print messages</title>"+css1+css2+'</head><body onload="window.focus(); window.print();window.close()"><div class="InnerContent">'+n+"</div></body></html>");
        r.document.write(`
                 <html>
                 <head>
                 ${css1}
                 ${css2}
                 <title></title>
                 </head>
                 <body class="chat-direction" onload="window.focus(); window.print();window.close()">
                 <div class="chat-direction" style="bottom: auto;">
                 <div class="chat-cont">
                 <div class="chat-head">
                 <label>${requestNo_title}: ${requestNo}</label>
                 <label>${ServiceName_title}: ${ServiceName}</label>
                 </div>
                 <div class="InnerContent">${messagesBody}</div>
                 </div>
                 </div>
                 </body>
                 </html>`);
        r.document.close();
    }
}
